import CloudImg from "public/openStack/heroicons_cloud-16-solid.png";
import SecImg from "public/openStack/tdesign_secured-filled.png";
import CubeImg from "public/openStack/Vector.png";

export const ADVANTAGES_CONSTANTS = [
  {
    image: CubeImg,
    title: "Fully Managed & Secure",
    text: "Modular and flexible design for efficient resource management",
    bgColor: "white",
  },
  {
    image: CloudImg,
    title: "Hybrid Integration",
    text: "Modular and flexible design for efficient resource management",
    bgColor: "white",
  },
  {
    image: SecImg,
    title: "Enterprise Security",
    text: "Modular and flexible design for efficient resource management",
    bgColor: "white",
  },
];
